module.exports = __webpack_public_path__ + "img/logo.40fd1cd6.jpg";